// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".plans[data-v-b1abacd6]{display:grid;grid-template-columns:repeat(auto-fit,minmax(300px,1fr));margin:1.5rem 0;text-align:left}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
